import { useMemo } from 'react';
import { GetStaticProps, GetStaticPaths } from 'next';
import { NextSeo } from 'next-seo';

import AggregateLayout from '~/components/discussions/AggregateLayout';

import {
  DEAL_COMMENT_TYPE,
  DISCUSSION,
  getQuestionSortOptions,
} from '~/lib/discussions/constants';
import useUser from '~/lib/user';
import { getDealStaticPaths, withDealStaticProps } from '~/lib/product/fetch';
import { Deal } from '~/types/deal';

export const getStaticProps: GetStaticProps = withDealStaticProps;
export const getStaticPaths: GetStaticPaths = getDealStaticPaths;

function QuestionAggregatePage({ deal }: { deal: Deal }) {
  const { user } = useUser();

  const isPartner = useMemo(() => {
    return deal.partner_user_ids.includes(user?.id || 0);
  }, [deal.partner_user_ids, user?.id]);

  return (
    <>
      <NextSeo title={`${deal.public_name} Questions`} />
      <AggregateLayout
        deal={deal}
        title="Questions"
        discussionType={DISCUSSION.QUESTIONS}
        commentType={DEAL_COMMENT_TYPE.QUESTION}
        sortOptions={getQuestionSortOptions({ isPartner })}
      />
    </>
  );
}

export default QuestionAggregatePage;
